'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _Parser = require('../Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _wrapper = require('./styled/wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _label = require('./styled/label');

var _label2 = _interopRequireDefault(_label);

var _checkbox = require('./styled/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _indicator = require('./styled/indicator');

var _indicator2 = _interopRequireDefault(_indicator);

var _innerLabel = require('./styled/inner-label');

var _innerLabel2 = _interopRequireDefault(_innerLabel);

var _fieldset = require('./styled/fieldset');

var _fieldset2 = _interopRequireDefault(_fieldset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxField = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CheckboxField, _Component);

  function CheckboxField(props) {
    (0, _classCallCheck3.default)(this, CheckboxField);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxField.__proto__ || (0, _getPrototypeOf2.default)(CheckboxField)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CheckboxField, [{
    key: 'onChange',
    value: function onChange(e) {
      this.props.onChange(e.target.checked);
      this.props.onBlur(e);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.props.value === '1' || this.props.value === true ? 'checked' : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var value = this.getValue();
      return _react2.default.createElement(
        _wrapper2.default,
        { labelDisplay: this.props.field['#title_display'] },
        _react2.default.createElement(
          _label2.default,
          { htmlFor: this.key },
          _react2.default.createElement(_checkbox2.default, {
            type: 'checkbox',
            onChange: this.onChange,
            value: value,
            checked: value,
            name: this.props.field['#webform_key'],
            id: this.props.id || this.props.field['#webform_key'],
            disabled: !this.props.state.enabled,
            required: this.props.state.required
          }),
          _react2.default.createElement(_indicator2.default, null),
          _react2.default.createElement(
            _innerLabel2.default,
            { className: 'hrw-inner-label' },
            (0, _Parser2.default)(this.props.field['#description'])
          )
        )
      );
    }
  }]);
  return CheckboxField;
}(_react.Component), _class2.meta = {
  wrapper: _fieldset2.default,
  label: _Fieldset2.default.meta.label,
  wrapperProps: _Fieldset2.default.meta.wrapperProps,
  field_display: {
    '#description': 'NO_DESCRIPTION'
  }
}, _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#webform_key': _propTypes2.default.string.isRequired,
    '#title_display': _propTypes2.default.string,
    '#description': _propTypes2.default.string,
    '#required': _propTypes2.default.bool
  }).isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  id: _propTypes2.default.number,
  onChange: _propTypes2.default.func.isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  state: _propTypes2.default.shape({
    required: _propTypes2.default.bool.isRequired,
    enabled: _propTypes2.default.bool.isRequired
  }).isRequired
}, _class2.defaultProps = {
  id: 0
}, _temp)) || _class;

exports.default = CheckboxField;